(function () {
  var EXAMPLE_QUESTIONS = [
    "Do you deliver to my postal code?",
    "What's the difference between electric and wood-fired?",
    "How much is an 8' barrel sauna?",
    "What kind of wood do you use?",
    "Can I see one in person?",
    "Is delivery included in the price?",
    "What electric heater do you use?",
    "How long does delivery take?",
    "Do you deliver to Quebec?",
    "What's the cold plunge tub like?",
  ];

  var WAVE_MIN = 4;
  var WAVE_MAX = 5;

  function escapeHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function formatBotText(text) {
    return escapeHtml(text)
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(/\n/g, "<br>");
  }

  function initWidget(root) {
    if (root.dataset.aiChatInitialized) return;
    root.dataset.aiChatInitialized = "true";

    var apiUrl = root.getAttribute("data-api-url");
    var messagesEl = root.querySelector("[data-ai-chat-messages]");
    var ghostsEl = root.querySelector("[data-ai-chat-ghosts]");
    var formEl = root.querySelector("[data-ai-chat-form]");
    var inputEl = root.querySelector("[data-ai-chat-input]");
    var sendEl = root.querySelector("[data-ai-chat-send]");

    var history = [];
    var ghostsActive = true;
    var usedQuestions = [];
    var ghostTimers = [];
    var activeGhostPositions = [];

    function randomBetween(min, max) {
      return min + Math.random() * (max - min);
    }

    function pickGhostPosition() {
      var best = null;
      var bestDist = -1;
      for (var attempt = 0; attempt < 12; attempt++) {
        var left = randomBetween(4, 56);
        var top = randomBetween(4, 66);
        var minDist = Infinity;
        for (var i = 0; i < activeGhostPositions.length; i++) {
          var dx = left - activeGhostPositions[i].left;
          var dy = top - activeGhostPositions[i].top;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < minDist) minDist = dist;
        }
        if (activeGhostPositions.length === 0) minDist = Infinity;
        if (minDist > bestDist) {
          bestDist = minDist;
          best = { left: left, top: top };
        }
        if (minDist > 38) break;
      }
      return best;
    }

    function nextQuestion() {
      if (usedQuestions.length >= EXAMPLE_QUESTIONS.length) usedQuestions = [];
      var pool = EXAMPLE_QUESTIONS.filter(function (q) {
        return usedQuestions.indexOf(q) === -1;
      });
      var q = pool[Math.floor(Math.random() * pool.length)];
      usedQuestions.push(q);
      return q;
    }

    function spawnGhost() {
      if (!ghostsActive) return;

      var chip = document.createElement("div");
      chip.className = "ai-chat-ghost";
      chip.textContent = nextQuestion();

      var pos = pickGhostPosition();
      var rot = randomBetween(-5, 5);
      var holdMs = randomBetween(2600, 3800);

      chip.style.left = pos.left + "%";
      chip.style.top = pos.top + "%";
      chip.style.setProperty("--rot", rot + "deg");

      var posEntry = { left: pos.left, top: pos.top };
      activeGhostPositions.push(posEntry);

      chip.addEventListener("click", function () {
        if (!ghostsActive) return;
        var question = chip.textContent;
        stopGhosts();
        submitMessage(question);
      });

      ghostsEl.appendChild(chip);

      // Two rAFs so the browser commits the initial (opacity: 0) state
      // before we add the class that transitions it in — otherwise the
      // transition can get skipped if both styles land in the same tick.
      // A plain setTimeout is used instead of requestAnimationFrame because
      // rAF is fully suspended in backgrounded/hidden tabs (a visitor who
      // opens the page in a background tab would never see the fade-in),
      // while setTimeout still fires there, just possibly throttled.
      var fadeInTimer = setTimeout(function () {
        chip.classList.add("is-visible");
      }, 20);
      ghostTimers.push(fadeInTimer);

      var fadeOutTimer = setTimeout(function () {
        chip.classList.remove("is-visible");
        var removeTimer = setTimeout(function () {
          if (chip.parentNode) chip.parentNode.removeChild(chip);
          var idx = activeGhostPositions.indexOf(posEntry);
          if (idx !== -1) activeGhostPositions.splice(idx, 1);
          // Each chip replaces only itself, on its own randomized clock,
          // so the set never empties out and re-fills all at once — it's
          // a steady rotating cast, not synchronized waves.
          if (ghostsActive) {
            var delay = randomBetween(150, 700);
            var t = setTimeout(spawnGhost, delay);
            ghostTimers.push(t);
          }
        }, 620);
        ghostTimers.push(removeTimer);
      }, holdMs);
      ghostTimers.push(fadeOutTimer);
    }

    function startGhosts() {
      var count = Math.floor(randomBetween(WAVE_MIN, WAVE_MAX + 1));
      for (var i = 0; i < count; i++) {
        (function (i) {
          var t = setTimeout(spawnGhost, i * 220);
          ghostTimers.push(t);
        })(i);
      }
    }

    function stopGhosts() {
      if (!ghostsActive) return;
      ghostsActive = false;
      ghostTimers.forEach(function (t) {
        clearTimeout(t);
      });
      ghostTimers = [];
      if (ghostsEl) {
        ghostsEl.style.transition = "opacity 0.3s ease";
        ghostsEl.style.opacity = "0";
        setTimeout(function () {
          if (ghostsEl && ghostsEl.parentNode) ghostsEl.parentNode.removeChild(ghostsEl);
        }, 320);
      }
    }

    function addMessage(text, role, pending) {
      var div = document.createElement("div");
      div.className = "ai-chat-msg ai-chat-msg--" + role + (pending ? " is-pending" : "");
      if (role === "bot") {
        div.innerHTML = formatBotText(text);
      } else {
        div.textContent = text;
      }
      messagesEl.appendChild(div);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return div;
    }

    async function submitMessage(text) {
      text = text.trim();
      if (!text) return;

      addMessage(text, "user");
      inputEl.value = "";
      sendEl.disabled = true;
      var pendingEl = addMessage("Thinking...", "bot", true);

      try {
        var res = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ message: text, history: history }),
        });
        var data = await res.json();

        if (!res.ok) throw new Error(data.error || "Something went wrong. Please try again.");

        pendingEl.innerHTML = formatBotText(data.reply);
        pendingEl.classList.remove("is-pending");

        history.push({ role: "user", content: text });
        history.push({ role: "assistant", content: data.reply });
      } catch (err) {
        pendingEl.innerHTML = formatBotText(
          err.message || "Sorry, something went wrong. Please try again or contact us directly.",
        );
        pendingEl.classList.remove("is-pending");
      } finally {
        sendEl.disabled = false;
        inputEl.focus();
      }
    }

    formEl.addEventListener("submit", function (e) {
      e.preventDefault();
      if (ghostsActive) stopGhosts();
      submitMessage(inputEl.value);
    });

    startGhosts();
  }

  function init() {
    var widgets = document.querySelectorAll("[data-ai-chat-widget]");
    widgets.forEach(initWidget);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
